'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import Loading from '../components/loading';
import menuAction from '../actions/menuAction';
import contractorAction from '../actions/contractorAction';
import contractorStore from '../stores/contractorStore';
import filterAction from '../actions/filterAction';
import filterStore from '../stores/filterStore';
import ContractorHeader from '../setComponents/contractorComponents/contractorHeader';
import ContractorBody from './contractorComponents/contractorBody';
import ContractorDisplay from './contractorComponents/contractorDisplay';


class Contractor extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            staffs: filterStore.getState().staffs,
            iniLoadStaff: filterStore.getState().iniLoadStaff,
            processingFilter: filterStore.getState().processing,
            contractors: contractorStore.getState().contractors,
            processing: contractorStore.getState().processing,

            condos: contractorStore.getState().condos,
            iniLoadCondo: contractorStore.getState().iniLoadCondo,
            updating: contractorStore.getState().updating,
            staffId: contractorStore.getState().staffId,
            mcst: contractorStore.getState().mcst,
            search: contractorStore.getState().search,
            contractorId: contractorStore.getState().contractorId,
            searchMode: contractorStore.getState().searchMode,

        };
    }

    componentDidMount() {
        menuAction.pageNumber(8);
        contractorStore.listen(this.onChange);
        filterStore.listen(this.onFilterChange);

        if (!this.state.iniLoadCondo && !this.state.processing) {
            contractorAction.processing(true);
            contractorAction.getCondoList();
        }
        if (!this.state.iniLoadStaff) {
            filterAction.processing(true);
            filterAction.getEmployee();
        }

        contractorAction.reset();
    }
    componentWillUnmount() {
        contractorStore.unlisten(this.onChange);
        filterStore.unlisten(this.onFilterChange);
    }
    onFilterChange(state) {
        this.setState({
            processingFilter: state.processing,
            staffs: state.staffs,
            iniLoadStaff: state.iniLoadStaff
        });
    }
    onChange(state) {
        this.setState({
            iniLoadCondo: state.iniLoadCondo,
            condos: state.condos,
            iniLoad: state.iniLoad,
            processing: state.processing,
            contractors: state.contractors,
            updating: state.updating,
            search: state.search,
            contractorId: state.contractorId,
            mcst: state.mcst,
            staffId: state.staffId,
            searchMode: state.searchMode,
        });
    }

    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 0) {
            window.print();
        } else if (index == 1) {
            contractorAction.processing(true);
            contractorAction.getExportContractorList(this.state.searchMode, this.state.mcst, this.state.staffId, this.state.search);
        } 
    }
    render() {
        let contractorList, body = "", header = "";

        if (!this.state.updating) {
            header = (
                <ContractorHeader condos={this.state.condos} staffs={this.state.staffs} processing={this.state.processing} />
            );
            body = (
                <ContractorBody contractors={this.state.contractors} />
            );
        } else {
            body = (
                //new contractor
                <ContractorDisplay processing={this.state.processing} />
            );
        }

        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        {header}
                        <div className="divider"></div>
                        {body}
                        <div className="row">
                            <div className="col-md-4">
                                <div className="warning">{this.state.warningMsg}</div>
                                <button type="button" className="btn btn-primary us-cr"
                                    data-index="0" onClick={this.handleClick}>Print</button>
                                <button type="button" className="btn btn-primary us-cr"
                                    data-index="1" onClick={this.handleClick}>Export</button>
                               
                            </div>
                            <div className="clear"></div>
                        </div>
                    </div>
                </div>
                <Loading processing={this.state.processing || this.state.processingFilter} />
            </div>
        );
    }
}
export default Contractor;


// WEBPACK FOOTER //
// ./app/components/contractor.js